import { RedirectOption, RouteConfig } from 'vue-router';

import { legalRedirectGuard } from '@/router/guards';

import { PRIVACY_BASE_URL, TERMS_BASE_URL } from '@/config/external';

const Auth = () => import('@/views/auth/Auth.vue');
const AuthCallback = () => import('@/views/auth/AuthCallback.vue');
const AuthLink = () => import('@/views/auth/AuthLink.vue');

const Main = () => import('@/views/main/Main.vue');
const LandingPage = () => import('@/views/common/LandingPage.vue');
const Play = () => import('@/views/common/Play.vue');

const HS000V1 = () => import('@/views/homescapes/lp/HS000V1.vue');
const HS002 = () => import('@/views/homescapes/lp/HS002.vue');

const LandingV1 = () => import('@/views/township/LandingV1.vue');
const LandingV4 = () => import('@/views/township/LandingV4.vue');
const LandingV5 = () => import('@/views/township/LandingV5.vue');

const HS_DEFAULT_ROUTE: RedirectOption = { name: 'hs001v1' };
const TS_DEFAULT_ROUTE: RedirectOption = { name: 'townshipLandingPage' };

export default [
  {
    path: '/',
    name: 'main',
    component: Main,
  },
  {
    path: '/township',
    name: 'township',
    redirect: TS_DEFAULT_ROUTE,
  },
  {
    path: '/township/play',
    name: 'townshipPlay',
    component: Play,
  },
  {
    path: '/township/lp',
    name: 'townshipLandingPage',
    component: LandingPage,
    meta: { impression: true },
  },
  {
    path: '/township/lp1',
    name: 'townshipLandingPageV1',
    component: LandingV1,
    meta: { impression: true },
  },
  {
    path: '/township/lp4',
    name: 'townshipLandingPageV4',
    component: LandingV4,
    meta: { impression: true },
  },
  {
    path: '/township/lp5',
    name: 'townshipLandingPageV5',
    component: LandingV5,
    meta: { impression: true },
  },
  {
    path: '/homescapes',
    name: 'homescapes',
    redirect: HS_DEFAULT_ROUTE,
  },
  {
    path: '/homescapes/play',
    name: 'homescapesPlay',
    component: Play,
  },
  {
    path: '/homescapes/lp',
    name: 'homescapesLandingPage',
    component: LandingPage,
    children: [
      {
        path: 'hs000v1',
        name: 'hs000v1',
        component: HS000V1,
      },
      {
        path: 'hs001v1',
        name: 'hs001v1',
        component: LandingPage,
        meta: { impression: true },
      },
      {
        path: 'hs002v1',
        name: 'hs002v1',
        component: HS002,
        props: {
          version: 1,
        },
        meta: { impression: true },
      },
      {
        path: 'hs002v2',
        name: 'hs002v2',
        component: HS002,
        props: {
          version: 2,
        },
        meta: { impression: true },
      },
      {
        path: 'hs002v3',
        name: 'hs002v3',
        component: HS002,
        props: {
          version: 3,
        },
        meta: { impression: true },
      },
    ],
  },
  {
    path: '/homescapes/game',
    redirect: { name: 'homescapesPlay' },
  },
  {
    path: '/play',
    redirect: { name: 'homescapesPlay' },
  },
  {
    path: '/game',
    redirect: { name: 'homescapesPlay' },
  },
  {
    path: '/auth',
    name: 'auth',
    component: Auth,
    meta: { requiresAnon: true },
  },
  {
    path: '/auth/callback',
    name: 'authCallback',
    component: AuthCallback,
    props: ({ query }) => ({
      code: query.code,
      state: query.state,
      scope: query.scope,
    }),
    meta: { requiresAnon: true },
  },
  {
    path: '/auth/link',
    name: 'authLink',
    component: AuthLink,
    props: ({ query }) => ({
      token: query.token,
    }),
    meta: { requiresAuth: true },
  },
  {
    path: '/auth/blank',
    name: 'authBlank',
    beforeEnter(to, from, next) {
      return next({ name: 'main' });
    },
  },
  {
    path: '/privacy',
    name: 'privacy',
    beforeEnter: legalRedirectGuard,
    meta: {
      redirect: PRIVACY_BASE_URL,
    },
  },
  {
    path: '/terms',
    name: 'terms',
    beforeEnter: legalRedirectGuard,
    meta: {
      redirect: TERMS_BASE_URL,
    },
  },
  {
    path: '*',
    redirect: { name: 'main' },
  },
] as Array<RouteConfig>;
